import axios from 'axios';

export async function fetchDegreeDays(
  buildingId: string,
  startDate: string,
  endDate: string
): Promise<{
  accumulated: number;
  count: number;
  average: number;
}> {
  const response = await axios.get<{
    accumulated: number;
    count: number;
    average: number;
  }>('/api/v1/degree-days', {
    params: { buildingId, startDate, endDate },
  });
  return response.data;
}

export async function fetchHeatingCoolingAnalysis(
  buildingId: string,
  months: number[]
): Promise<{ month: number; heating_percentage: number }[]> {
  const response = await axios.get<
    { month: number; heating_percentage: number }[]
  >('/api/v1/degree-days/heating-cooling-analysis', {
    params: { buildingId, months: months.join(',') },
  });
  return response.data;
}

export async function createDegreeDays(
  latitude: number,
  longitude: number,
  startDate: string,
  endDate: string,
  buildingId: string
): Promise<Record<string, number>> {
  const response = await axios.post<{ degreeDays: Record<string, number> }>(
    '/api/v1/degree-days',
    { latitude, longitude, startDate, endDate, buildingId }
  );
  return response.data.degreeDays;
}
